import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["postcodeInput", "townInput", "tbody", "row", "sortIndicator"]
    static values = {
        sortKey: { type: String, default: "" },
        sortDirection: { type: String, default: "asc" }
    }

    connect() {
        this.prepareRows()
    }

    prepareRows() {
        this.rowTargets.forEach((row) => {
            const cells = row.querySelectorAll("td")

            row.dataset.postcodeFilterPostcode = (cells[0]?.textContent || "").trim().toLowerCase()
            row.dataset.postcodeFilterTown = (cells[1]?.textContent || "").trim().toLowerCase()

            row.dataset.area = row.dataset.area || "0"
            row.dataset.population = row.dataset.population || "0"
            row.dataset.populationDensity =
                row.dataset.populationDensity ||
                row.getAttribute("data-population-density") ||
                "0"
        })
    }

    filterIfChanged(event) {
        const input = event.currentTarget
        const currentValue = (input.value || "").trim()
        const lastValue = input.dataset.lastValue || ""

        if (currentValue === lastValue) return

        input.dataset.lastValue = currentValue
        this.applyFilter()
    }

    sort(event) {
        const button = event.currentTarget
        const key = button.dataset.sortKey
        if (!key) return

        const nextDirection =
            this.sortKeyValue === key && this.sortDirectionValue === "asc" ? "desc" : "asc"

        this.sortKeyValue = key
        this.sortDirectionValue = nextDirection

        const sortedRows = [...this.rowTargets].sort((a, b) => {
            const aVal = parseFloat(a.dataset[key] || "0")
            const bVal = parseFloat(b.dataset[key] || "0")

            if (nextDirection === "asc") return aVal - bVal
            return bVal - aVal
        })

        sortedRows.forEach((row) => this.tbodyTarget.appendChild(row))

        this.updateSortIndicators()
        this.applyFilter()
    }

    applyFilter() {
        const postcodeQuery = (this.hasPostcodeInputTarget ? this.postcodeInputTarget.value : "").trim().toLowerCase()
        const townQuery = (this.hasTownInputTarget ? this.townInputTarget.value : "").trim().toLowerCase()

        this.rowTargets.forEach((row) => {
            const postcode = row.dataset.postcodeFilterPostcode || ""
            const town = row.dataset.postcodeFilterTown || ""

            const postcodeMatches = postcodeQuery === "" || postcode.startsWith(postcodeQuery)
            const townMatches = townQuery === "" || town.includes(townQuery)

            row.style.display = postcodeMatches && townMatches ? "" : "none"
        })
    }

    updateSortIndicators() {
        this.sortIndicatorTargets.forEach((indicator) => {
            const key = indicator.dataset.sortIndicator
            if (key === this.sortKeyValue) {
                indicator.textContent = this.sortDirectionValue === "asc" ? "▲" : "▼"
            } else {
                indicator.textContent = ""
            }
        })
    }
}